export default __webpack_public_path__ + "static/media/balance.dc9bc524.png";